import React from 'react'

import { useQuery } from '@apollo/client'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import { UPCOMING_MATCHES } from '@graphql/globalwidget/rankings.query'
import CustomLink from '@shared/components/customLink'
import FlagTeam from '@assets/images/placeholder/team-placeholder.svg'
import { convertDt24h, dateCheck } from '@shared-submodule/utils'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import WidgetCardHeader from '../widgetHeader'

const MyImage = dynamic(() => import('@shared/components/myImage'))
const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })

function UpcomingMatches() {
  const { data, loading } = useQuery(UPCOMING_MATCHES, {
    variables: {
      input: {
        nLimit: 5,
        nOrder: 1,
        nSkip: 0,
        sSortBy: 'dStartDate'
      }
    },
    context: { headers: { 'Cache-Control': 'public, max-age=300, s-maxage=600, stale-while-revalidate=420' } }
  })
  return (
    <>
      {data?.listUpcomingMatches?.length !== 0 && (
        <section className="widget">
          <WidgetCardHeader headerText={'Upcoming Matches'} link={allRoutes.fixturesUpcomingNew} internalLink={true} />
          <div className={`${styles.tabContainer} font-semi items common-box xsmall-text px-md-2 py-0`}>
            <div className={styles.list}>
              {data?.listUpcomingMatches?.map((data, i) => {
                return (
                  <div key={i} className={`${styles.item} p-2 p-md-3 d-flex justify-content-between align-items-center position-relative`}>
                    <div className={`${styles.team} font-semi d-flex align-items-center`}>
                      <div className={`${styles.flag}`}>
                        <MyImage
                          src={data?.oTeamA?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamA?.oImg?.sUrl}` : FlagTeam}
                          placeholderImage={FlagTeam}
                          errorImage={FlagTeam}
                          width="162"
                          height="162"
                          autoRadiusImage
                          alt={data?.oTeamA?.oImg?.sText}
                          layout="responsive"
                          sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                        />
                      </div>
                      <span className="mx-2">{data?.oTeamA?.sAbbr}</span>
                    </div>
                    <p className="mb-0">{convertDt24h(dateCheck(data?.dStartDate))}</p>
                    <div className={`${styles.team} font-semi d-flex align-items-center`}>
                      <span className="mx-2">{data?.oTeamB?.sAbbr}</span>
                      <div className={`${styles.flag}`}>
                        <MyImage
                          src={data?.oTeamB?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamB?.oImg?.sUrl}` : FlagTeam}
                          placeholderImage={FlagTeam}
                          errorImage={FlagTeam}
                          width="162"
                          height="162"
                          alt={data?.oPlayer?.oImg?.sText}
                          autoRadiusImage
                          layout="responsive"
                          sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                        />
                      </div>
                    </div>
                    {data?.oSeo?.sSlug ? <CustomLink href={`/${data?.oSeo?.sSlug}`} prefetch={false}>
                      <a className={`${styles.fullLink} position-absolute`}></a>
                    </CustomLink> : null}
                  </div>
                )
              })}
            </div>

            {loading &&
              [0, 1, 2, 3, 4].map((i) => (
                <div key={i} className="p-2 p-md-3 d-flex justify-content-between align-items-center">
                  <Skeleton width="22%" height={'25px'} />
                  <Skeleton width="28%" height={'17px'} />
                  <Skeleton width="22%" height={'25px'} />
                </div>
              ))}
          </div>
        </section>
      )}
    </>
  )
}

export default UpcomingMatches
